<template>
    <div
        v-if="local_value"
        class="aup-base-modal d-flex align-items-center justify-content-center"
        :class="{'aup-base-modal--fullscreen-mobile': fullscreenMobile, 'aup-base-modal--flush-body': flushBody}"
        role="dialog"
        aria-modal="true"
        @click.self="closeModal()"
    >
        <BaseShadowCard class="aup-base-modal__content" :style="{'max-width': maxWidth}" :class="{'p-0': noPadding, 'rounded': rounded}">
            <div class="aup-base-modal__content__header">
                <slot name="header"></slot>
            </div>
            <div class="aup-base-modal__content__body" :class="{'aup-base-modal__content__body--height-auto':bodyHeightAuto}">
                <slot name="body"></slot>
            </div>
            <div class="aup-base-modal__content__footer">
                <slot name="footer"></slot>
            </div>
        </BaseShadowCard>
    </div>
</template>

<script>
export default {
    name: "BaseModal",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: "md"
        },
        disableClose: {
            type: Boolean,
            default: false
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
        bodyHeightAuto: {
            type: Boolean,
            default: false,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
        // below 760px the card becomes a full-screen dialog
        fullscreenMobile: {
            type: Boolean,
            default: false,
        },
        // body content manages its own padding and sticky header (review step)
        flushBody: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            local_value: this.value,
        };
    },
    computed: {
        maxWidth() {
            var sizeWidth = this.size || "";
            if (this.size == 'sm') {
                sizeWidth = '400px';
            } else if ( this.size == 'md') {
                sizeWidth = '720px';
            } else if (this.size == 'lg') {
                sizeWidth = '1200px';
            }
            return sizeWidth;
        }
    },
    watch: {
        value(val) {
            this.local_value = val;
        },
        local_value(val) {
            this.toggleBodyFixed();
            this.$emit('input', val);
        }
    },
    methods: {
        toggleBodyFixed() {
            if (this.local_value) {
				document.body.style.overflow = "hidden";
            } else {
				document.body.style.overflow = "auto";
            }
        },
        closeModal() {
            if (!this.disableClose) {
				this.local_value = false;
				this.$emit('onClose');
            }
        }
    }
};
</script>

<style lang="scss">
    @import '../../assets/scss/all.scss';
    .aup-base-modal {
        z-index: map-get($zindices, modal);
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.651);
        width: 100%;
        height: 100%;
        overflow-x: hidden;

        &__content {
            width: 90%;

            &__body {
                height: 80vh;
                overflow-x: hidden;
                overflow-y: auto;
                &--height-auto {
                    height:auto;
                }
            }
        }

        &--flush-body &__content {
            padding: 0;
        }

        @media (max-width: 759px) {
            &--fullscreen-mobile &__content {
                width: 100%;
                max-width: none !important;
                height: 100%;
                display: flex;
                flex-direction: column;
                padding: 0 16px;
            }

            &--fullscreen-mobile &__content__body {
                flex: 1 1 auto;
                height: auto;
                min-height: 0;
                -webkit-overflow-scrolling: touch;
            }

            &--fullscreen-mobile.aup-base-modal--flush-body &__content {
                padding: 0;
            }
        }
    }
</style>
